import { Icon } from "@focus/focusUI";
import type { FC } from "react";

export type ConfigurationApp = {
  name: string;
  label: string;
  icon?: string;
  description?: string;
  container: FC;
  required?: string[];
};

export type ConfigurationGroup = {
  id: string;
  label: string;
  apps: ConfigurationApp[];
};

type SettingsMenuProps = {
  groups: ConfigurationGroup[];
  selected?: string;
  onSelect: (name: string) => void;
};

export const SettingsMenu: FC<SettingsMenuProps> = ({
  groups,
  selected,
  onSelect,
}) => {
  return (
    <nav className="flex h-full min-h-0 flex-col bg-slate-50/70">

      <div className="min-h-0 flex-1 overflow-y-auto p-3">
        <div className="flex flex-col gap-4">
          {groups.map((group) => (
            <section key={group.id}>
              <div className="mb-2 px-2 text-xs font-bold uppercase text-slate-500">
                {group.label}
              </div>

              <div className="flex flex-col gap-1">
                {group.apps.map((app) => {
                  const isSelected = selected === app.name;

                  return (
                    <button
                      aria-current={isSelected ? "page" : undefined}
                      className={`group flex w-full cursor-pointer items-start gap-3 rounded-xl border px-3 py-2.5 text-left transition ${
                        isSelected
                          ? "border-slate-300 bg-white text-slate-950 shadow-sm"
                          : "border-transparent text-slate-600 hover:border-slate-200 hover:bg-white/80 hover:text-slate-950"
                      }`}
                      key={app.name}
                      onClick={() => onSelect(app.name)}
                      type="button"
                    >
                      {app.icon && (
                        <span
                          className={`mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                            isSelected
                              ? "focusoc-theme-surface"
                              : "bg-slate-100 text-slate-500 group-hover:text-slate-700"
                          }`}
                        >
                          <Icon icon={app.icon} />
                        </span>
                      )}

                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-bold">
                          {app.label}
                        </span>
                        {app.description && (
                          <span className="mt-0.5 block text-xs font-medium leading-5 text-slate-500">
                            {app.description}
                          </span>
                        )}
                      </span>
                    </button>
                  );
                })}
              </div>
            </section>
          ))}
        </div>
      </div>
    </nav>
  );
};
